"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var propsFilter_1 = require("../../library/propsFilter");
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
var Content_1 = require("./Content");
var Footer_1 = require("./Footer");
var Header_1 = require("./Header");
var Side_1 = require("./Side");
require("./layout.css");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.layoutElement = null;
        _this.state = {
            bodyMarginTop: 0,
        };
        return _this;
    }
    Layout.prototype.findChild = function (element) {
        if (Array.isArray(this.props.children)) {
            return this.props.children.filter(function (e) { return e.type === element; })[0] || undefined;
        }
        return this.props.children.type === Header_1.Header ? this.props.children : undefined;
    };
    Layout.prototype.renderChild = function (element) {
        return this.findChild(element) || null;
    };
    Layout.prototype.getMaxWidth = function () {
        if (!this.props.maxWidth) {
            return undefined;
        }
        return this.props.maxWidth
            .map(function (width) {
            switch (width.type) {
                case 'full':
                    return "{\n                            max-width: ".concat(width.maxWidth, "px;\n                        }");
                case 'full_range':
                    return "@media only screen and (min-width: ".concat(width.minResolution, "px)\n                            and (max-width: ").concat(width.maxResolution, "px) {\n                            max-width: ").concat(width.maxWidth, "px;\n                        }");
                case 'low':
                    return "@media only screen and (min-width: ".concat(width.minResolution, "px) {\n                            max-width: ").concat(width.maxWidth, "px;\n                        }");
                case 'max':
                    return "@media only screen and (max-width: ".concat(width.maxResolution, "px) {\n                            max-width: ").concat(width.maxWidth, "px;\n                            ;\n                        }");
            }
        })
            .concat(["margin: 0 auto"]);
    };
    Layout.prototype.renderHeader = function () {
        var _this = this;
        var header = this.findChild(Header_1.Header);
        if (!header) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: React.cloneElement(header, __assign(__assign({}, (header.props.fixed
                ? {
                    onLoad: function (e) {
                        return _this.setState({
                            bodyMarginTop: e.currentTarget.getBoundingClientRect().height -
                                (_this.props.borderLess ? 0 : 14),
                        });
                    },
                }
                : {})), (header.props.fixed || header.props.hasRow
                ? {
                    maxWidth: this.getMaxWidth(),
                }
                : {}))) }));
    };
    Layout.prototype.getBodyChildren = function () {
        if (!Array.isArray(this.props.children)) {
            return this.props.children.type === Header_1.Header ? null : this.props.children;
        }
        return this.props.children.filter(function (e) { return e.type !== Header_1.Header && e.type !== Footer_1.Footer; });
    };
    Layout.prototype.renderBody = function (css) {
        var h = this.findChild(Header_1.Header);
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('body', { 'body-full': this.findChild(Side_1.Side) === undefined }, css({
                marginTop: h && (h.props.fixed || h.props.hasRow) ? "".concat(this.state.bodyMarginTop, "px") : '0px',
            })) }, { children: this.getBodyChildren() })));
    };
    Layout.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
                var css = _a.css;
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "layout" }, (0, propsFilter_1.getAllDataProps)(_this.props, _this.context), { children: [_this.renderHeader(), (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('layout-page', { 'border-less': _this.props.borderLess ? true : false }, _this.props.maxWidth ? css(_this.getMaxWidth()) : undefined) }, { children: [_this.renderBody(css), _this.renderChild(Footer_1.Footer)] }))] })));
            } }));
    };
    Layout.Header = Header_1.Header;
    Layout.Footer = Footer_1.Footer;
    Layout.Content = Content_1.Content;
    Layout.Side = Side_1.Side;
    Layout.contextType = SharkMorphContext_1.SharkMorphContext;
    return Layout;
}(React.PureComponent));
exports.Layout = Layout;
//# sourceMappingURL=Layout.js.map